var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('public-head',{staticClass:"title",attrs:{"backgroundImage":_vm.bg,"subTitle":"INVESTOR RELATIONS","title":"投资者关系","show":true}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }